function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgLogoSansiroMenu = function SvgLogoSansiroMenu(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 69.465 36.37",
    style: {
      enableBackground: "new 0 0 69.465 36.37"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#484848"
    },
    d: "M30.376,32.727v-2.805h0.339v2.805H30.376z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#484848"
    },
    d: "M33.138,32.727l-0.87-2.134h-0.011l0,2.134h-0.313l0.009-2.805h0.407l0.832,2.145h0.011l0.009-2.145 h0.313l0.009,2.805H33.138z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#484848"
    },
    d: "M36.089,32.631c-0.106,0.064-0.234,0.096-0.385,0.096c-0.148,0-0.281-0.035-0.4-0.106 c-0.118-0.07-0.217-0.168-0.298-0.294c-0.08-0.126-0.142-0.273-0.185-0.443c-0.043-0.17-0.064-0.355-0.064-0.556 c0-0.201,0.022-0.387,0.066-0.558c0.044-0.171,0.107-0.319,0.188-0.443c0.082-0.124,0.181-0.222,0.298-0.292 c0.117-0.07,0.248-0.106,0.394-0.106c0.136,0,0.26,0.026,0.373,0.079c0.113,0.053,0.206,0.133,0.279,0.241l-0.211,0.23 c-0.055-0.08-0.119-0.14-0.192-0.179c-0.073-0.039-0.151-0.058-0.234-0.058c-0.103,0-0.192,0.029-0.268,0.087 c-0.075,0.058-0.138,0.136-0.187,0.234c-0.049,0.098-0.086,0.213-0.111,0.345c-0.025,0.132-0.038,0.272-0.038,0.42 c0,0.148,0.013,0.288,0.038,0.418c0.025,0.131,0.063,0.246,0.113,0.345c0.05,0.099,0.114,0.178,0.19,0.236 c0.077,0.058,0.166,0.087,0.27,0.087c0.093,0,0.175-0.025,0.247-0.075c0.072-0.05,0.129-0.112,0.172-0.185l0.204,0.222 C36.281,32.482,36.195,32.567,36.089,32.631z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#484848"
    },
    d: "M39.427,31.325c0,0.209-0.021,0.399-0.062,0.571c-0.041,0.172-0.102,0.32-0.181,0.443 c-0.079,0.123-0.175,0.219-0.286,0.286c-0.112,0.068-0.239,0.102-0.383,0.102c-0.143,0-0.271-0.034-0.385-0.102 c-0.113-0.068-0.209-0.163-0.288-0.286c-0.079-0.123-0.139-0.271-0.181-0.443c-0.041-0.172-0.062-0.362-0.062-0.571 c0-0.209,0.02-0.399,0.06-0.571c0.04-0.172,0.099-0.319,0.177-0.441c0.078-0.122,0.174-0.216,0.288-0.283 c0.114-0.067,0.244-0.1,0.39-0.1c0.143,0,0.271,0.033,0.383,0.1c0.112,0.067,0.207,0.161,0.286,0.283 c0.079,0.122,0.139,0.269,0.181,0.441C39.407,30.926,39.427,31.116,39.427,31.325z M39.069,31.325c0-0.151-0.012-0.293-0.036-0.426 c-0.024-0.133-0.059-0.249-0.106-0.347c-0.047-0.098-0.104-0.175-0.173-0.232c-0.069-0.057-0.149-0.085-0.239-0.085 c-0.093,0-0.175,0.028-0.245,0.085c-0.07,0.057-0.129,0.134-0.175,0.232c-0.047,0.098-0.081,0.214-0.104,0.347 c-0.023,0.133-0.034,0.275-0.034,0.426c0,0.151,0.011,0.293,0.034,0.426c0.023,0.133,0.057,0.249,0.104,0.347 c0.046,0.098,0.105,0.175,0.175,0.232c0.07,0.057,0.152,0.085,0.245,0.085c0.09,0,0.17-0.028,0.239-0.085 c0.069-0.057,0.127-0.134,0.173-0.232c0.046-0.098,0.082-0.214,0.106-0.347C39.057,31.617,39.069,31.475,39.069,31.325z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#484848"
    },
    d: "M41.822,32.727l-0.511-1.319h-0.309l0,1.319H40.67l0-2.797h0.692c0.098,0,0.191,0.013,0.278,0.04 c0.087,0.026,0.163,0.069,0.229,0.126c0.065,0.058,0.117,0.133,0.155,0.226c0.038,0.093,0.057,0.205,0.057,0.336 c0,0.108-0.014,0.202-0.042,0.283c-0.028,0.08-0.064,0.149-0.109,0.205c-0.045,0.057-0.093,0.101-0.146,0.134 c-0.053,0.033-0.105,0.054-0.155,0.064l0.56,1.383H41.822z M41.74,30.671c0-0.091-0.013-0.165-0.038-0.223 c-0.025-0.058-0.058-0.105-0.098-0.14c-0.04-0.035-0.087-0.06-0.139-0.074c-0.053-0.014-0.106-0.021-0.158-0.021h-0.305v0.931 h0.313c0.128,0,0.231-0.041,0.309-0.123C41.701,30.939,41.74,30.822,41.74,30.671z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#484848"
    },
    d: "M44.697,30.68c0,0.128-0.019,0.241-0.057,0.339c-0.038,0.098-0.089,0.179-0.153,0.243 c-0.064,0.064-0.137,0.112-0.219,0.145c-0.082,0.033-0.168,0.049-0.258,0.049h-0.362v1.27H43.31V29.93h0.677 c0.081,0,0.163,0.012,0.248,0.036c0.084,0.024,0.161,0.065,0.229,0.123c0.068,0.058,0.124,0.135,0.168,0.232 C44.675,30.417,44.697,30.537,44.697,30.68z M44.358,30.684c0-0.161-0.038-0.278-0.112-0.352c-0.075-0.074-0.173-0.111-0.292-0.111 h-0.304v0.954h0.304c0.12,0,0.217-0.041,0.292-0.123C44.321,30.97,44.358,30.847,44.358,30.684z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#484848"
    },
    d: "M47.768,31.325c0,0.209-0.021,0.399-0.062,0.571c-0.041,0.172-0.102,0.32-0.181,0.443 c-0.079,0.123-0.175,0.219-0.286,0.286c-0.112,0.068-0.239,0.102-0.383,0.102c-0.143,0-0.271-0.034-0.385-0.102 c-0.113-0.068-0.209-0.163-0.288-0.286c-0.079-0.123-0.139-0.271-0.181-0.443c-0.041-0.172-0.062-0.362-0.062-0.571 c0-0.209,0.02-0.399,0.06-0.571c0.04-0.172,0.099-0.319,0.177-0.441c0.078-0.122,0.174-0.216,0.288-0.283 c0.114-0.067,0.244-0.1,0.39-0.1c0.143,0,0.271,0.033,0.383,0.1c0.112,0.067,0.207,0.161,0.286,0.283 c0.079,0.122,0.139,0.269,0.181,0.441C47.747,30.926,47.768,31.116,47.768,31.325z M47.41,31.325c0-0.151-0.012-0.293-0.036-0.426 c-0.024-0.133-0.059-0.249-0.106-0.347c-0.047-0.098-0.104-0.175-0.173-0.232c-0.069-0.057-0.149-0.085-0.239-0.085 c-0.093,0-0.175,0.028-0.245,0.085c-0.07,0.057-0.129,0.134-0.175,0.232c-0.047,0.098-0.081,0.214-0.104,0.347 c-0.023,0.133-0.034,0.275-0.034,0.426c0,0.151,0.011,0.293,0.034,0.426c0.023,0.133,0.057,0.249,0.104,0.347 c0.046,0.098,0.105,0.175,0.175,0.232c0.07,0.057,0.152,0.085,0.245,0.085c0.09,0,0.17-0.028,0.239-0.085 c0.069-0.057,0.127-0.134,0.173-0.232c0.046-0.098,0.082-0.214,0.106-0.347C47.398,31.617,47.41,31.475,47.41,31.325z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#484848"
    },
    d: "M50.162,32.727L49.651,31.4h-0.309l0,1.327H49.01l0-2.805h0.692c0.098,0,0.191,0.013,0.278,0.04 c0.087,0.026,0.163,0.069,0.229,0.126c0.065,0.058,0.117,0.133,0.155,0.226c0.038,0.093,0.057,0.205,0.057,0.336 c0,0.108-0.014,0.202-0.042,0.283c-0.028,0.08-0.064,0.149-0.109,0.205c-0.045,0.057-0.093,0.101-0.146,0.134 c-0.053,0.033-0.105,0.054-0.155,0.064l0.56,1.391H50.162z M50.081,30.663c0-0.091-0.013-0.165-0.038-0.223 c-0.025-0.058-0.058-0.105-0.098-0.14c-0.04-0.035-0.087-0.06-0.139-0.074c-0.053-0.014-0.106-0.021-0.158-0.021h-0.305v0.931 h0.313c0.128,0,0.231-0.041,0.309-0.123C50.042,30.931,50.081,30.814,50.081,30.663z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#484848"
    },
    d: "M53.164,32.727l-0.182-0.762h-0.773l-0.188,0.762h-0.343l0.704-2.805h0.449l0.688,2.805H53.164z  M52.609,30.239h-0.015l-0.339,1.459h0.682L52.609,30.239z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#484848"
    },
    d: "M56.376,31.323c0,0.453-0.092,0.798-0.276,1.036c-0.184,0.238-0.442,0.357-0.774,0.357h-0.64v-2.795 h0.644c0.332,0,0.589,0.12,0.772,0.359C56.284,30.521,56.376,30.868,56.376,31.323z M56.02,31.323c0-0.184-0.018-0.345-0.053-0.482 c-0.035-0.137-0.084-0.25-0.145-0.34c-0.062-0.089-0.135-0.157-0.22-0.201c-0.085-0.045-0.176-0.067-0.273-0.067h-0.287v2.171 h0.287c0.097,0,0.188-0.022,0.273-0.067c0.085-0.045,0.159-0.112,0.22-0.201c0.062-0.089,0.11-0.202,0.145-0.338 C56.003,31.664,56.02,31.505,56.02,31.323z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#484848"
    },
    d: "M59.413,31.325c0,0.209-0.021,0.399-0.062,0.571c-0.041,0.172-0.102,0.32-0.181,0.443 c-0.079,0.123-0.175,0.219-0.286,0.286c-0.112,0.068-0.239,0.102-0.383,0.102c-0.143,0-0.271-0.034-0.385-0.102 c-0.113-0.068-0.209-0.163-0.288-0.286c-0.079-0.123-0.139-0.271-0.181-0.443c-0.041-0.172-0.062-0.362-0.062-0.571 c0-0.209,0.02-0.399,0.06-0.571c0.04-0.172,0.099-0.319,0.177-0.441c0.078-0.122,0.174-0.216,0.288-0.283 c0.114-0.067,0.244-0.1,0.39-0.1c0.143,0,0.271,0.033,0.383,0.1c0.112,0.067,0.207,0.161,0.286,0.283 c0.079,0.122,0.139,0.269,0.181,0.441C59.393,30.926,59.413,31.116,59.413,31.325z M59.055,31.325c0-0.151-0.012-0.293-0.036-0.426 c-0.024-0.133-0.059-0.249-0.106-0.347c-0.047-0.098-0.104-0.175-0.173-0.232c-0.069-0.057-0.149-0.085-0.239-0.085 c-0.093,0-0.175,0.028-0.245,0.085c-0.07,0.057-0.129,0.134-0.175,0.232c-0.047,0.098-0.081,0.214-0.104,0.347 c-0.023,0.133-0.034,0.275-0.034,0.426c0,0.151,0.011,0.293,0.034,0.426c0.023,0.133,0.057,0.249,0.104,0.347 c0.046,0.098,0.105,0.175,0.175,0.232c0.07,0.057,0.152,0.085,0.245,0.085c0.09,0,0.17-0.028,0.239-0.085 c0.069-0.057,0.127-0.134,0.173-0.232c0.046-0.098,0.082-0.214,0.106-0.347C59.043,31.617,59.055,31.475,59.055,31.325z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#484848"
    },
    d: "M61.799,32.727L61.297,31.4h-0.309v1.327h-0.332v-2.805h0.692c0.098,0,0.191,0.013,0.278,0.04 c0.087,0.026,0.163,0.069,0.229,0.126c0.065,0.058,0.117,0.133,0.155,0.226c0.038,0.093,0.057,0.205,0.057,0.336 c0,0.108-0.014,0.202-0.042,0.283c-0.028,0.08-0.064,0.149-0.109,0.205c-0.045,0.057-0.093,0.101-0.146,0.134 c-0.053,0.033-0.105,0.054-0.155,0.064l0.551,1.391H61.799z M61.726,30.663c0-0.091-0.013-0.165-0.038-0.223 c-0.025-0.058-0.058-0.105-0.098-0.14c-0.04-0.035-0.087-0.06-0.139-0.074c-0.053-0.014-0.106-0.021-0.158-0.021h-0.305v0.931H61.3 c0.128,0,0.231-0.041,0.309-0.123C61.687,30.931,61.726,30.814,61.726,30.663z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#484848"
    },
    d: "M64.79,32.727l-0.18-0.762h-0.773l-0.186,0.762h-0.343l0.703-2.805h0.449l0.686,2.805H64.79z  M64.237,30.239h-0.015l-0.339,1.459h0.682L64.237,30.239z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.947,
    y: 7.651,
    style: {
      fill: "#484848"
    },
    width: 2.993,
    height: 3.022
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40.643,
    y: 21.025,
    style: {
      fill: "#484848"
    },
    width: 2.993,
    height: 7.43
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40.643,
    y: 16.435,
    style: {
      fill: "#484848"
    },
    width: 2.993,
    height: 3.022
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#484848"
    },
    d: "M46.629,14.97h2.993V3h-1.496v0H42.14v2.993h4.489v1.496H42.14v0h-1.496v4.489v1.585v1.408 L46.629,14.97L46.629,14.97z M43.636,11.978v-1.496h2.992v1.496H43.636z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#484848"
    },
    points: "54.108,5.993 57.101,5.993 57.101,14.971 60.093,14.971 60.093,3 58.597,3 58.597,3  51.115,3 51.115,4.696 51.115,4.696 51.115,14.87 54.108,14.87  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#484848"
    },
    points: "30.171,4.496 30.171,5.993 30.171,7.489 30.171,8.985 30.171,10.482 36.157,10.482  36.157,11.978 30.171,11.978 30.171,14.971 36.157,14.971 37.653,14.971 39.149,14.971 39.149,7.489 37.653,7.489 37.653,7.489  33.164,7.489 33.164,5.993 39.149,5.993 39.149,3 30.171,3  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#484848"
    },
    d: "M54.468,23.946v-7.482h-1.485v0H45.13v2.993h0v8.998h2.993v-4.509h0.148l4.13,4.509l2.067,0.002 v-2.176l-2.139-2.335H54.468z M51.475,19.457v1.496h-3.353v-1.496H51.475z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#484848"
    },
    d: "M63.444,16.465L63.444,16.465l-7.482,0v2.993h0v8.978h2.993v0h2.993v0h2.993V16.465H63.444z  M58.955,25.443v-5.985h2.993v5.985H58.955z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#484848"
    },
    points: "30.171,19.457 30.171,19.457 30.171,20.954 30.171,20.954 30.171,23.946 36.157,23.946  36.157,25.443 30.171,25.443 30.171,28.435 36.157,28.435 37.653,28.435 39.149,28.435 39.149,23.946 39.149,22.561 39.149,20.954  33.164,20.954 33.164,19.457 39.149,19.457 39.149,16.465 30.171,16.465  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#484848"
    },
    d: "M16.957,19.914c0,0-0.001,0-0.001-0.001c0.013,0.013,0.027,0.029,0.037,0.038 c-0.002-0.002-0.004-0.003-0.006-0.005C16.978,19.934,16.968,19.924,16.957,19.914z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#484848"
    },
    d: "M15.878,25.862c1.637,1.003,3.277,2.001,4.911,3.01c0.262,0.162,0.254,0.021,0.253-0.174 c-0.002-1.877-0.006-3.755,0.003-5.632c0.001-0.293-0.075-0.311-0.307-0.175c-1.638,0.957-3.281,1.907-4.95,2.875 C15.831,25.813,15.85,25.845,15.878,25.862z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#484848"
    },
    d: "M26.537,19.168c0.241-0.139,0.211-0.211-0.006-0.336c-0.968-0.559-1.931-1.128-2.896-1.693 c-0.731-0.428-1.462-0.854-2.251-1.315c0,2.067,0.003,4.061-0.004,6.055c-0.001,0.279,0.114,0.213,0.264,0.126 C23.274,21.058,24.903,20.108,26.537,19.168z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#484848"
    },
    d: "M21.023,15.862c-1.76,1.108-3.484,2.195-5.249,3.306c0.005,0.01,0.01,0.021,0.016,0.031 c1.683,0.95,3.317,1.87,4.947,2.797c0.234,0.133,0.309,0.112,0.308-0.179c-0.009-1.902-0.005-3.805-0.005-5.707 C21.04,16.043,21.031,15.978,21.023,15.862z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#484848"
    },
    d: "M15.65,18.828c0.001,0.006,0.004,0.011,0.005,0.016c0.002,0.001,0.003,0.003,0.005,0.004 c1.736-1.094,3.476-2.19,5.221-3.289c-0.03-0.032-0.041-0.053-0.059-0.064c-1.653-0.978-3.308-1.953-4.959-2.934 c-0.325-0.193-0.279,0.035-0.279,0.224c0,1.048,0.001,2.096,0.001,3.144c0.003,0.134,0.003,0.267,0,0.401 c0,0.753,0,1.507,0.001,2.26c0,0.023-0.004,0.049-0.007,0.074C15.601,18.72,15.624,18.775,15.65,18.828z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#484848"
    },
    d: "M21.392,29.041c1.772-1.028,3.496-2.028,5.261-3.052c0.038-0.04,0.074-0.081,0.109-0.123 c-1.813-1.057-3.577-2.086-5.371-3.131C21.392,24.858,21.392,26.92,21.392,29.041z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#484848"
    },
    d: "M15.013,25.727c-0.6-0.349-1.201-0.698-1.802-1.047c-0.007-0.001-0.015-0.003-0.022-0.003 c-0.002-0.001-0.004-0.003-0.006-0.005c-0.002-0.004-0.005-0.008-0.008-0.013c-0.366-0.212-0.731-0.425-1.097-0.637 c-0.005,0-0.01-0.001-0.015-0.001c-0.003,0-0.005,0.001-0.008,0.001c-0.047-0.034-0.098-0.062-0.145-0.097c0,0,0,0,0,0 c-0.689-0.4-1.378-0.801-2.067-1.201c-0.315-0.183-0.227,0.081-0.228,0.211c-0.004,1.926-0.003,3.852,0,5.778 c0,0.071-0.047,0.164,0.066,0.221c1.796-1.041,3.597-2.085,5.4-3.131C15.044,25.76,15.032,25.738,15.013,25.727z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#484848"
    },
    d: "M15.261,26.082c-1.835,1.064-3.634,2.107-5.471,3.173c1.815,1.051,3.58,2.074,5.366,3.108 c0.035,0.006,0.07,0.011,0.105,0.014C15.261,30.252,15.261,28.187,15.261,26.082z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#484848"
    },
    d: "M9.281,28.629c-0.011-0.934-0.004-1.867-0.004-2.801c0-0.934,0.001-1.867-0.001-2.801 c-0.001-0.373-0.006-0.378-0.331-0.19c-1.458,0.843-2.913,1.69-4.372,2.529c-0.003,0.003-0.007,0.006-0.01,0.01 c-0.001,0-0.003-0.001-0.004-0.002c-0.152,0.088-0.304,0.176-0.456,0.263c-0.267,0.153-0.172,0.226,0.018,0.336 c0.055,0.032,0.111,0.064,0.166,0.096c0.032,0.006,0.064,0.013,0.095,0.023c0.007,0.002,0.014,0.005,0.02,0.007 c0.016,0.009,0.033,0.018,0.05,0.027c0.014,0.021,0.028,0.041,0.041,0.062c1.5,0.867,3,1.735,4.496,2.609 C9.213,28.928,9.284,28.901,9.281,28.629z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#484848"
    },
    d: "M20.677,29.183c-1.6-0.975-3.198-1.952-4.793-2.936c-0.23-0.142-0.269-0.071-0.267,0.16 c0.007,0.851,0.003,1.703,0.003,2.554c0,1.127,0,2.254,0,3.402c0.053-0.009,0.106-0.021,0.158-0.036 c1.635-0.956,3.269-1.915,4.906-2.868C20.879,29.344,20.843,29.284,20.677,29.183z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#484848"
    },
    d: "M26.913,20.747c0.019-0.024,0.037-0.049,0.054-0.074c0-0.458,0-0.916,0-1.377 c-1.814,1.053-3.595,2.086-5.419,3.144c1.831,1.068,3.596,2.098,5.41,3.156c0.003-0.005,0.006-0.01,0.009-0.014 c0-1.589,0-3.149,0-4.72C26.95,20.823,26.932,20.784,26.913,20.747z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#484848"
    },
    d: "M2.862,10.16c0,2.066,0,4.081,0,6.134c1.781-1.032,3.522-2.04,5.293-3.066 C6.381,12.2,4.635,11.188,2.862,10.16z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#484848"
    },
    d: "M8.066,6.862c-0.435,0.27-0.881,0.524-1.322,0.785C5.513,8.376,4.281,9.105,3.006,9.86 c1.737,1.009,3.428,1.989,5.117,2.973c0.238,0.139,0.212-0.023,0.212-0.168c0-1.889-0.004-3.779,0.004-5.668 C8.339,6.717,8.255,6.746,8.066,6.862z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#484848"
    },
    d: "M8.101,13.639c-0.662,0.39-1.328,0.772-1.992,1.157c-1.024,0.594-2.048,1.188-3.11,1.803 c1.733,1.102,3.432,2.182,5.13,3.263c0.205,0.13,0.206-0.002,0.206-0.148c0-1.983-0.002-3.965,0.003-5.948 C8.338,13.537,8.269,13.539,8.101,13.639z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#484848"
    },
    d: "M8.636,12.707c-0.001,0.242,0.093,0.211,0.247,0.126c0.755-0.416,1.512-0.829,2.268-1.243 c0.979-0.536,1.958-1.071,2.997-1.64c-1.863-1.092-3.663-2.148-5.509-3.23C8.639,8.766,8.641,10.737,8.636,12.707z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#484848"
    },
    d: "M14.277,17.024c-0.032,0.01-0.066,0.014-0.094,0.031c-1.709,1.023-3.416,2.049-5.128,3.068 c-0.251,0.15-0.144,0.218,0.03,0.318c1.645,0.949,3.292,1.896,4.929,2.86c0.296,0.174,0.306,0.076,0.305-0.191 c-0.007-1.938-0.003-3.875-0.005-5.813C14.313,17.209,14.344,17.114,14.277,17.024z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#484848"
    },
    d: "M14.285,3.398c-1.835,1.018-3.634,2.016-5.474,3.036c1.836,1.077,3.637,2.134,5.474,3.212 C14.285,7.542,14.285,5.492,14.285,3.398z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#484848"
    },
    d: "M8.769,19.906c1.708-1.021,3.413-2.046,5.123-3.064c0.251-0.15,0.138-0.22-0.033-0.32 c-1.652-0.958-3.303-1.917-4.951-2.881c-0.193-0.113-0.274-0.125-0.273,0.147c0.008,2.041,0.004,4.081,0.004,6.159 C8.707,19.927,8.742,19.923,8.769,19.906z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#484848"
    },
    d: "M14.719,9.619c1.722-1.049,3.45-2.101,5.223-3.182c-1.72-0.989-3.387-1.947-5.052-2.909 c-0.294-0.17-0.239,0.045-0.239,0.2c-0.001,1.88-0.001,3.76,0.001,5.639C14.652,9.443,14.621,9.529,14.719,9.619z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#484848"
    },
    points: "14.412,23.871 14.418,23.875 14.419,23.873  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#484848"
    },
    d: "M20.424,6.716c0,2.112,0,4.166,0,6.262c1.832-1.038,3.629-2.056,5.467-3.097 C24.047,8.813,22.251,7.773,20.424,6.716z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#484848"
    },
    d: "M20.055,6.735c-1.77,1.078-3.503,2.133-5.276,3.212c1.777,1.024,3.508,2.022,5.276,3.04 C20.055,10.886,20.055,8.839,20.055,6.735z"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLogoSansiroMenu, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logo-sansiro-menu.e3a34523.svg";
export { ForwardRef as ReactComponent };